import React from "react";
import Loader from "../../components/common/Loader";
import Footer from "../../components/home1/Footer";
import Menu from "../../components/innerpage/Menu";
import Navbar from "../../components/home1/Navbar";
//import StartButton from "../../components/home5_residence/StartButton";
import Slider from "../../components/innerpage/single_post/Slider";
import Content from "../../components/innerpage/single_post/Content";
import Comments from "../../components/innerpage/single_post/Comments";
import { Helmet } from "react-helmet";
import { SITE_NAME } from "../../seoConfig";

function SinglePost() {
  return (
    <>
      <Helmet>
        <title>{`Blog Post | ${SITE_NAME}`}</title>
        <meta
          name="description"
          content="Read the full article from our architecture and interior design studio's blog."
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/navbar-fix.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <body className="inner-pages-style1 post-pg-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <main>
            <Slider />
            <Content />
            <Comments />
          </main>
          <Footer />
        </div>
      </body>
    </>
  );
}

export default SinglePost;
